import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import './LandingPage.scss';
import { GameEngine } from '../../../Components/GameEngine';
import { QRCodeSVG } from 'qrcode.react';

const LandingPage = () => {
  const {t} = useTranslation();
  const [showMessage, setShowMessage] = useState(false);
  const link = `${origin}`;
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      setShowMessage(true);
    }, 5000);
  }, []);


  return (
    <>
      { showMessage &&
        <div className="center_dialog_box_new trial_play">

          <div className="actions">
            <button className="outlined green play_btn" onClick={() => navigate('/Trial')}>{t('trial.playNow')}</button>
            <button className="outlined red" onClick={() => setShowMessage(false)}>{t('trial.close')}</button>
          </div>
          <div className="qr-container">
            <QRCodeSVG
              value={link}
              size={200}
              level="M"
              includeMargin
            />
          </div>
          <div className="message">{t('trial.popupText')}</div>

        </div>
      }
      <GameEngine
        title={'Play60s'}
        containerClass={'landing_page'}
        gameType={null}
        trial={true}
        noBet={true}
        login={true}
        website={true}
      />
    </>
  );
};

export default LandingPage;
